import { isNil } from 'lodash';
import { GeometryType } from 'shared/cesium';
import wkt from 'wkt';

/**
 * SAM predictions may be returned as either POLYGON or MULTIPOLYGON WKT.
 *
 * The map rendering pipeline handles individual POLYGON imports reliably,
 * but does not correctly render a single MULTIPOLYGON WKT.
 *
 * Split MULTIPOLYGON geometries into separate POLYGON WKTs while preserving
 * any interior rings (holes).
 */
export const flattenPredictionWkts = (predictionWkt: string): string[] => {
  const trimmed = predictionWkt.trim();

  if (!trimmed) {
    return [];
  }

  try {
    const geometry = wkt.parse(trimmed);

    if (
      geometry?.type !== GeometryType.MultiPolygon ||
      isNil(geometry.coordinates)
    ) {
      return [trimmed];
    }

    return geometry.coordinates.map((polygonCoords) =>
      wkt.stringify({
        type: GeometryType.Polygon,
        coordinates: polygonCoords,
      }),
    );
  } catch (error) {
    console.error('[PolygonAI] Failed to parse prediction WKT', error);

    return [trimmed];
  }
};
